var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitterGrey = function SvgTwitterGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15.438,
    viewBox: "0 0 19 15.438",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter-grey-icon",
    d: "M19,3.828a8.121,8.121,0,0,1-2.244.615A3.874,3.874,0,0,0,18.469,2.29,7.784,7.784,0,0,1,16,3.233,3.895,3.895,0,0,0,9.261,5.9a4.011,4.011,0,0,0,.09.888A11.025,11.025,0,0,1,1.323,2.71a3.9,3.9,0,0,0,1.2,5.206,3.848,3.848,0,0,1-1.76-.48v.043a3.913,3.913,0,0,0,3.121,3.827,3.888,3.888,0,0,1-1.021.128,3.444,3.444,0,0,1-.737-.066,3.932,3.932,0,0,0,3.64,2.713,7.826,7.826,0,0,1-4.83,1.661A7.3,7.3,0,0,1,0,15.689a10.965,10.965,0,0,0,5.975,1.748A11.01,11.01,0,0,0,17.062,6.353c0-.172-.006-.338-.014-.5A7.771,7.771,0,0,0,19,3.828Z",
    transform: "translate(0 -1.999)",
    fill: "#7c98b6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter-grey.600a1070.svg";
export { ForwardRef as ReactComponent };